import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { AppState } from "../app.state";
import { ISopoLoadingState, LoadingState } from "./loading.state";
import * as loadingActions from "./loading.actions";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class LoadingDispatcher {
    constructor(private store: Store<AppState>) {}

    getLoadingState(): Observable<ISopoLoadingState> {
        return this.store.select('loading');
    }

    presentLoading(loadingKey: keyof LoadingState) {
        this.store.dispatch(loadingActions.presentLoading({loadingKey}));
    }

    dismissLoading(loadingKey: keyof LoadingState) {
        this.store.dispatch(loadingActions.dismissLoading({loadingKey}));
    }

    dismissAllLoading() {
        this.store.dispatch(loadingActions.dismissAllLoading());
    }

    pauseLoading() {
        this.store.dispatch(loadingActions.pauseLoading());
    }

    resumeLoading() {
        this.store.dispatch(loadingActions.resumeLoading());
    }
}
